import React from "react";
import { connect } from "react-redux";
import { FormOutlined, ContactsOutlined, GlobalOutlined } from '@ant-design/icons';
import { ProfileCreateStyle } from "./style";
import DynamicForm from "../../../../../components/DynamicFormNew";
import { actions as stakeholderActions } from '../../../../../store/reducers/stakeholder';
import { displayMessage, MessageTypes } from "../../../../../helpers/Messages";
import { Modal } from "antd";
import i18next from "i18next";

const icons = {
  FormOutlined: FormOutlined,
  ContactsOutlined: ContactsOutlined,
  GlobalOutlined: GlobalOutlined
}
function ProfileCreate({
  onSubmitted,
  formOptions,
  formValue,
  stakeholderSubmit,
  activeFormIndex,
  disabledInputs = [],
}) {
  return <ProfileCreateStyle>
    <DynamicForm
      excludedKeys={['dsUserId', 'mStatus']}
      icons={icons}
      form={formOptions}
      data={formValue}
      module={'cadd'}
      activeFormIndex={activeFormIndex}
      disabledInputs={disabledInputs}
      submit={(payload, setSelectedFormNext, close) => {
        const callback = (type, message) => {
          const roleChanged = payload.dueDiligenceRole !== formValue.dueDiligenceRole;
          if (type === MessageTypes.SUCCESS) {
            if (setSelectedFormNext && !close) {
              setSelectedFormNext()
              if (!roleChanged) {
                displayMessage(type, message);
              }
            } else {
              if (onSubmitted && !roleChanged) onSubmitted(type, message);
            }
            if (roleChanged) {
              Modal.info({
                title: i18next.t('Due diligence role'),
                content: i18next.t('Your due diligence role is under review'),
                okText: 'Ok',
                onOk: () => { },
                maskClosable: true,
              })
            }
          }
        }
        stakeholderSubmit((!formValue && !formValue.id)
          ? Object.assign(payload, { module: 'cadd', view: 'identification' })
          : Object.assign(payload, { id: formValue.id, module: 'cadd', view: 'identification' }), callback);
      }}
    ></DynamicForm>
  </ProfileCreateStyle>
}

ProfileCreate.defaultProps = {
  activeFormIndex: '',
};

export default connect(({ authentication, stakeholder }) =>
  ({ authentication, stakeholder }), stakeholderActions)(ProfileCreate);
